import { environment } from "@environments/environment";
import { IProteinCategories } from "@interfaces/myaccount";

export enum SiteCookies {
    ACCESSTOKEN = 'C_SESSION_ID',
    REFRESHTOKEN = 'C_REFRESHER',
    ORDERPLACED = 'ORDER_PLACED'
}

export enum SiteStorage {
    RETURNURL = 'return_url',
    ISAGEMODALVIEWED = 'isAgeModal_viewed',
    CANCEL_SUBSCRIPTION = 'cancel_subscription',
    ISSUBSTITUTIONMODALDECLINED = 'isSubstitutionModal_declined'
}

export const Global = {
    pageText: {
        login: {
            pageTitle: 'Log into Your Account',
            promotionMessageTitle: 'Claim Your $50 Reactivation Discount',
            promotionMessageDesc: 'Simply log in below and click "Yes"',
            pageReactivationTitle: 'Reactivate your Chef Ami account'
        },
        forgotPassword: {
            pageTitle: 'Forgot Password - Chef Ami'
        },
        changePassword: {
            pageTitle: 'Change Password - Chef Ami'
        },
        deliverySchedule: {
            pageTitle: 'Upcoming Deliveries - Chef Ami'
        },
        referral: {
            pageTitle: 'Referral - Chef Ami'
        },
        freeBoxes: {
            pageTitle: 'My freebox - Chef Ami'
        },
        myAccount: {
            pageTitle: 'My Account  - Chef Ami'
        },
        myOrders: {
            pageTitle: 'My orders - Chef Ami'
        },
        orderDetails: {
            pageTitle: 'Order details - Chef Ami'
        },
        membershipSettings: {
            pageTitle: 'Subscription Settings - Chef Ami'
        },
        wallets: {
            pageTitle: 'Wallets - Chef Ami'
        },
        thankYou: {
            pageTitle: 'Thank You - Chefami'
        },
        donations: {
            pageTitle: 'Donations - Chef Ami'
        },
        myRatings: {
            pageTitle: 'My Ratings - Chef Ami'
        },
        noPageFound: {
            pageTitle: 'Error - Chef Ami'
        }
    },
    VEGETARIAN: 'vegetarian'
};

export const FieldErrors: any = {
    email: {
        required: 'Please enter email.',
        pattern: 'Please enter a valid email.'
    },
    password: {
        required: 'Please enter password.'
    },
    first_name: {
        required: 'Please enter first name.'
    },
    last_name: {
        required: 'Please enter last name.'
    },
    address: {
        required: 'Please enter address.'
    },
    city: {
        required: 'Please enter city.'
    },
    state: {
        required: 'Please enter state.'
    },
    postalCode: {
        required: 'Please enter postal code.',
        pattern: 'Please enter 5 digit postal code.'
    },
    phone: {
        required: 'Please enter phone number.',
        pattern: 'Please enter 10 digit numbers only.'
    },
    new_password: {
        required: 'Please enter new password.',
        invalid: 'Current password and new password are same.'
    },
    confirm_password: {
        required: 'Please re enter new password.',
        mismatch: 'Confirm password does not match to new password.'
    },
    nameOnCard: {
        required: 'Please enter name.'
    },
    ageRange: {
        required: 'Please select your age range.'
    },
    plan_type: {
        required: 'Please select your plan.'
    },
    no_of_recipes: {
        required: 'Please select your number of recipes.'
    },
    no_of_persons: {
        required: 'Please select your number of persons.'
    },
    full_name: {
        required: 'Please enter friend\'s full name.'
    },
    coupon: {
        required: 'Please enter coupon code.'
    },
    date: {
        required: 'Please select first delivery date.'
    },
    surveyValue: {
        required: 'Please select an option.'
    },
    surveyText: {
        required: 'Please enter a description.'
    },
    recommendationRating: {
        required: 'Please select your recommendation rating.'
    },
    feedback_message: {
        required: 'Please give your feedback.'
    },
    proteins: {
        required: 'You cannot avoid all proteins.'
    },
    notes: {
        maxlength: 'Please enter less than 120 characters.'
    }
};

export const patterns: any = {
    email: /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/, // /^[a-zA-Z0-9_+&*-]*[a-zA-Z]+[a-zA-Z0-9_+&*-]*(?:\.[a-zA-Z0-9_+&*-]+)*@(?:[a-zA-Z0-9]+\.)+[a-zA-Z]{2,7}$/
    postalCode: '^[0-9]{5}$',
    phone: '^[0-9]{10}$'
}

export const SiteText = {
    TECHNICAL_ERROR: "Sorry! There is a technical issue. Please try again later.",
    SESSION_ERROR: "Your session has expired. Please sign in again.",
    EMPTY_RECORDS: "No records found.",
    NO_RECIPES: "No recipes found.",
    PAYMENT_UPDATE_ERROR: "Sorry! There is an issue updating your card. Please try another payment method.",
    PAYMENT_PROCESSING: "Card update in on processing. Please reach out to admin for more info.",
    SELECT_RATING: "Please provide rating to atleast one meal."
}

const path = environment.imagePath;

export const ImagePaths = {
    BOX_ICON: path + 'BOX.svg',
    CHEFAMI_BOX_ICON: path + 'BOX-04.svg',
    GIFT_CARD_ICON: path + 'GIFTCARD.svg',
    MEGA_PHONE_ICON: path + 'MEGAPHONE.svg',
    THANK_YOU_GIF: path + 'thank_you.gif',
    FISH_ICON: path + 'FISH.svg',
    FISH_COLOR_ICON: path + 'FISH_COLOR.svg',
    PORK_ICON: path + 'PORK.svg',
    PORK_COLOR_ICON: path + 'PORK_COLOR.svg',
    POULTRY_ICON: path + 'POULTRY.svg',
    POULTRY_COLOR_ICON: path + 'POULTRY_COLOR.svg',
    RED_MEAT_ICON: path + 'RED_MEAT.svg',
    RED_MEAT_COLOR_ICON: path + 'RED_MEAT_COLOR.svg',
    SALMON_ICON: path + 'SALMON.svg',
    SALMON_COLOR_ICON: path + 'SALMON_COLOR.svg',
    SHELLFISH_ICON: path + 'SHELLFISH.svg',
    SHELLFISH_COLOR_ICON: path + 'SHELLFISH_COLOR.svg',
    VEGETARIAN_ICON: path + 'VEGETARIAN.svg',
    VEGETARIAN_COLOR_ICON: path + 'VEGETARIAN_COLOR.svg',
    WHITE_MEAT_ICON: path + 'WHITE_MEAT.svg',
    WHITE_MEAT_COLOR_ICON: path + 'WHITE_MEAT_COLOR.svg',
    DONATION_BANNER: path + 'donation-banner.jpg',
    DONATION_GIFT: path + 'gift.png',
    LOGO: path + 'logo.png',
    DONATION_BOX: path + 'BOX_01.svg',
    DONACTION_BOX_HEART: path + 'BOX-HEART.svg'
};

export const ProteinCategoriesList: Array<IProteinCategories> = [
    {
        id: 0,
        name: 'Beef',
        description: '',
        normal_image: ImagePaths.RED_MEAT_ICON,
        active_image: ImagePaths.RED_MEAT_COLOR_ICON,
        slug: 'beef'
    },
    {
        id: 0,
        name: 'Pork',
        description: '',
        normal_image: ImagePaths.PORK_ICON,
        active_image: ImagePaths.PORK_COLOR_ICON,
        slug: 'pork'
    },
    {
        id: 0,
        name: 'Poultry (white meat)',
        description: 'white meat',
        normal_image: ImagePaths.WHITE_MEAT_ICON,
        active_image: ImagePaths.WHITE_MEAT_COLOR_ICON,
        slug: 'poultry_white'
    },
    {
        id: 0,
        name: 'Poultry (dark meat)',
        description: 'dark meat',
        normal_image: ImagePaths.POULTRY_ICON,
        active_image: ImagePaths.POULTRY_COLOR_ICON,
        slug: 'poultry_dark'
    },
    {
        id: 0,
        name: 'Shellfish',
        description: '',
        normal_image: ImagePaths.SHELLFISH_ICON,
        active_image: ImagePaths.SHELLFISH_COLOR_ICON,
        slug: 'shellfish'
    },
    {
        id: 0,
        name: 'Fish',
        description: '',
        normal_image: ImagePaths.FISH_ICON,
        active_image: ImagePaths.FISH_COLOR_ICON,
        slug: 'fish'
    },
    {
        id: 0,
        name: 'Salmon',
        description: '',
        normal_image: ImagePaths.SALMON_ICON,
        active_image: ImagePaths.SALMON_COLOR_ICON,
        slug: 'salmon'
    },
    {
        id: 0,
        name: 'Vegetarian',
        description: '',
        normal_image: ImagePaths.VEGETARIAN_ICON,
        active_image: ImagePaths.VEGETARIAN_COLOR_ICON,
        slug: 'vegetarian'
    }
];

export enum SubscriptionStatus {
    PAUSED = 0,
    ACTIVE = 1,
    CANCELLED = 2,
    PERMANENT_PAUSED = 3
}

export enum DeliveryScheduleScreen {
    SELECT_MEAL = 'select_meal',
    CONFIRM_MEAL = 'confirm_meal'
}

export const CancelOptions = [
    {
      key : 'i_want_deliveries_on_tuesdays',
      name: 'I want deliveries on Tuesdays'
    },
    {
      key : 'too_hard_to_manage_my_deliveries',
      name: 'Too hard to manage my deliveries'
    },
    {
      key : 'price_is_too_high',
      name: 'Price is too high'
    },
    {
      key : 'disliked_the_food',
      name: 'Disliked the food'
    },
    {
      key : 'too_busy',
      name: 'Too busy'
    },
    {
      key : 'moving_out_of_the_area',
      name: 'Moving out of the area'
    },
    {
      key : 'i_wll_be_back',
      name: 'I\'ll be back!'
    },
    {
        key: 'using_another_meal_kit',
        name: 'Using Another Meal Kit'
    },
    {
        key: 'too_much_work_to_cook',
        name: 'Too much work to cook'
    },
    {
      key : 'other',
      name: 'Others'
    }
];

export const LatLngObj = {
    lat: 29.006029,
    lng: -82.332887
}